import { Colors, Router, VideoPlayer } from '@lightningjs/sdk';
import { Column } from '@lightningjs/ui-components';
import lng from '@lightningjs/core';
import srtParser2 from 'srt-parser-2';

// API
import { combinedCheckIn, finishWatching, getSingleMovie, startWatching } from '../../api/movies';

// Components
import SkipIntroBtn from './components/SkipIntroBtn';
import FocusContainer from './components/FocusContainer';
import { loader, unloader } from '../../components/HLS';
import PopupModal from './components/PopupModal';
import TvSpinner from './components/TvSpinner';
import { getDevice } from '../../utils/device';

let watchCredits = false;
let offsetTime = 0;
let startWatchTrackingId;
export default class Player extends lng.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      collision: true,
      LoadingContainer: {
        x: 0,
        y: 0,
        rect: true,
        visible: true,
        color: Colors('#00000000').get(),
        flex: { direction: 'row', justifyContent: 'center', alignItems: 'center' },
        type: TvSpinner,
      },
      Overlay: {
        w: 1920,
        h: 1080,
        rect: true,
        color: Colors('#000000').alpha(0.8).get(),
        visible: false,
      },
      PopupModal: {
        collision: true,
        type: PopupModal,
      },
      ProgressContainer: {
        rect: true,
        w: 1600,
        x: 160,
        h: 25,
        y: 950,
        ProgressBar: {
          type: Column,
          rect: true,
          color: Colors('#02AC25').get(),
          h: 25,
          w: 0,
        },
      },
      FocusCtn: {
        collision: true,
        type: FocusContainer,
        x: 158,
        y: 948,
        w: 1604,
        h: 30,
        rect: true,
        texture: lng.Tools.getRoundRect(1605, 28, 0, 3, Colors('#D6D6D6').get(), false),
      },
      CurrentTimeLabel: {
        w: 100,
        text: {
          fontFace: 'OpenSans-Regular',
          text: '00:00:00',
          textAlign: 'center',
          fontSize: 25,
          textColor: Colors('#ffffff').get(),
          shadow: true,
          shadowColor: Colors('#000000').get(),
          shadowOffsetX: 1,
          shadowOffsetY: 1,
          shadowBlur: 1,
        },
        x: 45,
        y: 947,
      },
      DurationLabel: {
        w: 100,
        // h: 25,
        text: {
          fontFace: 'OpenSans-Regular',
          textAlign: 'center',
          text: '00:00:00',
          fontSize: 25,
          textColor: Colors('#ffffff').get(),
          shadow: true,
          shadowColor: Colors('#000000').get(),
          shadowOffsetX: 1,
          shadowOffsetY: 1,
          shadowBlur: 1,
        },
        x: 1775,
        y: 947,
      },
      IntroEndsAt: {
        visible: false,
        x: 160,
        y: 850,
        w: 190,
        h: 85,
        color: Colors('#707070').get(),
        shader: { type: lng.shaders.RoundedRectangle, radius: 16 },
        rect: true,
        type: Column,
        SkipIntroBtn: {
          collision: true,
          type: SkipIntroBtn,
          Text: {
            x: 33,
            y: 23,
            text: {
              text: 'Skip intro',
              fontSize: 30,
            },
          },
        },
      },
      SubtitleText: {
        w: 1920,
        flex: {
          direction: 'row',
        },
        text: {
          text: '',
          fontFace: 'Arial',
          fontSize: 36,
          textColor: Colors('#ffffff').get(),
          textAlign: 'center',
          wordWrapWidth: 1200,
          highlight: true,
          highlightColor: Colors('#000000').alpha(0.8).get(),
          highlightPaddingLeft: 20,
          highlightPaddingRight: 20,
          lineHeight: 55,
        },
        y: 830,
      },
    };
  }

  get id() {
    return 'PlayerPage';
  }

  set params({
    subtitle,
    videoUrl,
    currentTime,
    videoDuration,
    introEndsAt,
    movieId,
    movieInfo,
    credits_start_at,
  }) {
    return (this._params = {
      subtitle,
      videoUrl,
      currentTime,
      videoDuration,
      introEndsAt: introEndsAt || '00:00:00',
      movieId,
      movieInfo,
      credits_start_at,
    });
  }

  _handleMediaPlayPause() {
    this._showUIElements(); // Show the UI elements when video starts playing
    this._restartHideUITimer(10000); // Restart the hide timer with 10 seconds
    VideoPlayer.playPause();
  }
  _handleMediaRewind() {
    if (!this.tag('PopupModal').visible) {
      this._showUIElements(); // Show the UI elements when video starts playing
      this._restartHideUITimer(10000); // Restart the hide timer with 10 seconds
      this._skipVideo(-10);
    }
  }
  _handleMediaFastForward() {
    if (!this.tag('PopupModal').visible) {
      this._showUIElements(); // Show the UI elements when video starts playing
      this._restartHideUITimer(10000); // Restart the hide timer with 10 seconds
      this._skipVideo(10);
    }
  }
  _handleMediaPlay() {
    this._showUIElements(); // Show the UI elements when video starts playing
    this._restartHideUITimer(10000); // Restart the hide timer with 10 seconds
    VideoPlayer.play();
  }
  _handleMediaPause() {
    this._showUIElements(); // Show the UI elements when video starts playing
    this._restartHideUITimer(10000); // Restart the hide timer with 10 seconds
    VideoPlayer.pause();
  }
  _handleMediaStop() {
    this._handleBack();
    VideoPlayer.close();
  }

  // Initialize VideoPlayer
  _firstActive() {
    VideoPlayer.consumer(this);
    VideoPlayer.loader(loader);
    VideoPlayer.unloader(unloader);
  }

  _enable() {
    this._hideUIElements();
    this._setState('ProgressBar');
  }

  _disable() {
    clearInterval(this._updateTimeIntervall);
    clearInterval(this._updateTimeInterval);
    clearInterval(this._startWatching);
    this.tag('PopupModal').visible = false;
    this._setState('ProgressBar');
  }

  _fetchAutoplayMovie() {
    const VODList = localStorage.getItem('VODList');
    const profileInfo = JSON.parse(localStorage.getItem('profileInfo'));

    // Proveri da li postoji VODList, da li je autoplay omogućen i da li VODList nije prazan
    if (VODList && profileInfo?.autoplay) {
      const parsedVODList = JSON.parse(VODList);

      if (Array.isArray(parsedVODList) && parsedVODList.length > 0) {
        return new Promise((resolve, reject) => {
          getSingleMovie(parsedVODList[0])
            .then(({ data }) => {
              this.movieDetails = data;
              this.tag('PopupModal').patch({
                type: PopupModal,
                data: data.movie,
                previousID: this._params.movieId,
              });
              resolve(data);
            })
            .catch((error) => {
              console.error('Error fetching movie details:', error);
              reject(error);
            });
        });
      }
    }

    return [];
  }

  $watchCredits() {
    if (VideoPlayer.currentTime == VideoPlayer.duration) {
      setTimeout(() => {
        this.tag('PopupModal').$PlayNextMovie();
        this._setState('ProgressBar');
      }, 200);
      return;
    }
    watchCredits = true;
    this.tag('PopupModal').patch({
      visible: false,
    });
    this.tag('Overlay').visible = false;
    this._setState('ProgressBar');
  }

  $setDefaultFocus() {
    this._setState('ProgressBar');
  }

  // $videoPlayerWaiting() {
  //   this.tag('Spinner').patch({
  //     visible: true,
  //   });
  //   this._spin();
  // }

  // $videoPlayerPlaying() {
  //   this.tag('Spinner').patch({
  //     visible: false,
  //   });
  // }

  // _spin() {
  //   this.tag('Spinner')
  //     .animation({
  //       duration: 2,
  //       repeat: -1,
  //       actions: [{ p: 'rotation', v: { 0: 0, 1: 10 * Math.PI } }],
  //     })
  //     .start();
  // }

  $videoPlayerLoadStart() {
    this.tag('LoadingContainer').patch({
      visible: true,
    });
  }

  $videoPlayerLoadedData() {
    this._updateTimeInterval = setInterval(() => {
      this._updateProgressBarAndTime();
    }, 1000);
    this.tag('LoadingContainer').patch({
      visible: false,
    });

    watchCredits = false;
    this.timeoutID = null;
    this._fetchAutoplayMovie();
    this.tag('DurationLabel').text.text = this._formatTime(VideoPlayer.duration);
    this._adjustSubtitleTextPosition(false);
    const resumeTime = this._params.currentTime;
    if (!isNaN(resumeTime)) {
      VideoPlayer.seek(resumeTime);
      VideoPlayer.play();
    } else {
      VideoPlayer.seek(0);
      VideoPlayer.play();
    }
    this._checkIn(1);
    // Now we move the _setState check to the end
    if (this.tag('PopupModal').visible == true) {
      this._setState('PopupModal');
    } else {
      if (this.tag('IntroEndsAt').visible) {
        this._setState('SkipIntro');
      } else {
        this._setState('ProgressBar');
      }
    }
    this._showUIElements(); // Show the UI elements when video starts playing
    this._restartHideUITimer(10000); // Restart the hide timer with 10 seconds
  }

  async _active() {
    this.fireAncestors('$punchHole');
    startWatching(this._params.movieId).then((res) => {
      startWatchTrackingId = res.data.tracking_id;
      const m3u8 =
        'https://stream.livingscriptures.com/api/v4' +
        `${this._params.videoUrl}` +
        `&token=${localStorage.getItem('userToken')}`;
      VideoPlayer.open(m3u8);
    });

    // Headers
    // this._startWatching = setInterval(() => {
    //   if (VideoPlayer.playing) {
    //     startWatching(this._params.movieId).then((res) => {
    //       const trackId = res.data.tracking_id;
    //       const deviceType = 'samsung_tizen_tv';
    //       const resumeTime = Math.round(VideoPlayer.currentTime);
    //       const resumeTimeString = resumeTime.toString();
    //       const watchSeconds = Math.round(VideoPlayer.currentTime);
    //       const data = {
    //         tracking_id: startWatchTrackingId,
    //         device: deviceType,
    //         resume_time: resumeTimeString,
    //         watch_seconds: 10,
    //       };
    //       combinedCheckIn(this._params.movieId, data);
    //     });
    //   }
    // }, 10000);
    this._startWatching = setInterval(() => {
      if (VideoPlayer.playing) {
        this._checkIn(10);
      }
    }, 10000);

    // Subtitles
    if (this._params.subtitle) {
      const parser = new srtParser2();
      try {
        const srtSubtitlesRes = await fetch(this._params.subtitle);
        const srtSubtitles = await srtSubtitlesRes.text();
        const subtitles = parser.fromSrt(srtSubtitles);

        this._updateTimeIntervall = setInterval(() => {
          const currentSubtitle = subtitles.find(
            (subtitle) =>
              VideoPlayer.currentTime >= subtitle.startSeconds &&
              VideoPlayer.currentTime <= subtitle.endSeconds
          );

          if (currentSubtitle) {
            let cleanedSubtitleText = currentSubtitle.text;

            // Check if the subtitle text contains <font> tags
            if (/<[^>]+>/.test(cleanedSubtitleText)) {
              // Remove <font> tags from subtitle text
              cleanedSubtitleText = cleanedSubtitleText.replace(/<[^>]+>/g, '');
            }
            this.patch({
              SubtitleText: undefined,
            });
            this.patch({
              SubtitleText: {
                w: 1920,
                y: this._subtitlePosition(),

                flex: {
                  direction: 'row',
                },
                visible: true,
                text: {
                  text: cleanedSubtitleText,
                  fontFace: 'Arial',
                  fontSize: 36,
                  textColor: Colors('#ffffff').get(),
                  textAlign: 'center',
                  wordWrapWidth: 1200,
                  highlight: true,
                  highlightColor: Colors('#000000').alpha(0.8).get(),
                  highlightPaddingLeft: 20,
                  highlightPaddingRight: 20,
                  lineHeight: 55,
                },
              },
            });
          } else {
            this.tag('SubtitleText').patch({
              visible: false,
            });
          }
        }, 900);
      } catch (error) {
        console.error('Failed to fetch subtitles:', error);
      }
    }
  }

  _checkIn(seconds) {
    let deviceType;
    switch (getDevice()) {
      case 'tizen':
        deviceType = 'samsung_tizen_tv';
        break;
      case 'webos':
        deviceType = 'lg_webos_tv';
        break;
      default:
        deviceType = 'lg_webos_tv';
    }
    const resumeTime = Math.round(VideoPlayer.currentTime);
    const resumeTimeString = resumeTime.toString();

    const data = {
      tracking_id: startWatchTrackingId,
      device: deviceType,
      resume_time: resumeTimeString,
      watch_seconds: seconds,
    };
    combinedCheckIn(this._params.movieId, data);
  }

  _handleBack() {
    this.tag('PopupModal').tag('Buttons').items[0]._clearTimeout();
    let currentVOD = localStorage.getItem('CurrentVOD');
    let routes = Router.getHistory();
    let lastRouteHash = routes[routes.length - 1].hash;
    const seriesPattern = /^series\/\d+/; // assuming ID is numeric, adjust \d+ if necessary
    const categoriesPattern = /^categories\/\d+/;
    if (currentVOD) {
      // Regular expression to check if hash starts with "series/"

      // Check if the last hash matches the pattern "series/{someId}"

      if (categoriesPattern.test(lastRouteHash) || lastRouteHash == 'browse') {
        routes.push({ hash: `movie/${currentVOD}` });
      } else {
        if (!seriesPattern.test(lastRouteHash)) {
          routes[routes.length - 1].hash = `movie/${currentVOD}`;
        } else {
          routes[routes.length - 1].hash = `series/${localStorage.getItem('seriesId')}`;
        }
      }

      Router.setHistory(routes);
    }

    if (categoriesPattern.test(lastRouteHash) || lastRouteHash == 'browse') {
      routes.push({ hash: `movie/${this._params.movieId}` });
      Router.setHistory(routes);
    }
    Router.back();
    localStorage.removeItem('CurrentVOD');
    VideoPlayer.close();
    clearInterval(this._updateTimeIntervall);
    clearInterval(this._updateTimeInterval);
    clearInterval(this._startWatching);
    this._resetUI();
    this.fireAncestors('$unpunchHole');
  }

  $videoPlayerEnded() {
    // let currentVOD = localStorage.getItem('CurrentVOD');
    // if (currentVOD) {
    //   let routes = Router.getHistory();
    //   routes[routes.length - 1].hash = `movie/${currentVOD}`;
    //   Router.setHistory(routes);
    // }
    // VideoPlayer.close();
    // setTimeout(() => {
    //   Router.back();
    //   localStorage.removeItem('CurrentVOD');
    //   this.fireAncestors('$unpunchHole');
    //   this._resetUI();
    // }, 10);
    // finishWatching(this._params.movieId);
    // clearInterval(this._updateTimeIntervall);
    // clearInterval(this._updateTimeInterval);
    // clearInterval(this._startWatching);
    if (this.tag('PopupModal').visible) {
      return;
    } else {
      let profileInfo = JSON.parse(localStorage.getItem('profileInfo'));
      let VODList = JSON.parse(localStorage.getItem('VODList'));
      if (profileInfo.autoplay && VODList?.length > 0) {
        this.tag('PopupModal').$PlayNextMovie();
        finishWatching(this._params.movieId);
      } else {
        this._handleBack();
        finishWatching(this._params.movieId);
      }
    }
  }

  $setState(state) {
    this._setState(state);
  }

  _handleClick() {
    VideoPlayer.playPause();
    this._showUIElements(); // Show the UI elements when video starts playing
    this._restartHideUITimer(10000); // Restart the hide timer with 10 seconds
    this._adjustSubtitleTextPosition(false);
  }

  _handleHover() {
    this._setState('ProgressBar');
    this._showUIElements(); // Show the UI elements when video starts playing
    this._restartHideUITimer(10000); // Restart the hide timer with 10 seconds
    this._adjustSubtitleTextPosition(false);
  }

  static _states() {
    return [
      class ProgressBar extends this {
        _getFocused() {
          return this.tag('FocusCtn');
        }
        _handleUp() {
          const introEndsAt = this._timeToSeconds(this._params.introEndsAt);
          if (VideoPlayer.currentTime < introEndsAt) {
            this._setState('SkipIntro');
          } else {
            this._showUIElements();
            this._restartHideUITimer(10000);
            this._setState('ProgressBar');
          }
        }
        _handleEnter() {
          if (!this.tag('PopupModal').visible) {
            VideoPlayer.playPause();
            this._showUIElements(); // Show the UI elements when video starts playing
            this._restartHideUITimer(10000); // Restart the hide timer with 10 seconds
            this._adjustSubtitleTextPosition(false);
          }
        }

        _handleLeft() {
          if (!this.tag('PopupModal').visible) {
            this._skipVideo(-10);
            this._showUIElements(); // Show the UI elements when video starts playing
            this._restartHideUITimer(10000); // Restart the hide timer with 10 seconds
          }
        }

        _handleRight() {
          if (!this.tag('PopupModal').visible) {
            this._skipVideo(10);
            this._showUIElements(); // Show the UI elements when video starts playing
            this._restartHideUITimer(10000); // Restart the hide timer with 10 seconds
          }
        }
      },

      class SkipIntro extends this {
        _getFocused() {
          return this.tag('IntroEndsAt.SkipIntroBtn');
        }
        _handleDown() {
          this._setState('ProgressBar');
          this._showUIElements(); // Show the UI elements when video starts playing
        }
        _handleEnter() {
          VideoPlayer.seek(this._timeToSeconds(this._params.introEndsAt) + 1);
          this._setState('ProgressBar');
          this.tag('IntroEndsAt').visible = false;
        }

        _handleClick() {
          this._handleEnter();
        }

        _handleLeft() {
          return true;
        }

        _handleRight() {
          return true;
        }
      },
      class PopupModal extends this {
        _getFocused() {
          return this.tag('PopupModal');
        }

        _handleUp() {
          return true;
        }

        _handleLeft() {
          return true;
        }
        _handleRight() {
          return true;
        }
      },
    ];
  }

  _updateProgressBarAndTime() {
    // Ensure currentTime doesn't go below 0 or exceed videoDuration
    const currentTime = Math.max(
      0,
      Math.min(VideoPlayer.currentTime + offsetTime, VideoPlayer.duration)
    );
    const videoDuration = VideoPlayer.duration;

    const introEndsAtInSeconds = this._timeToSeconds(this._params.introEndsAt);
    const creditsStartAtInSeconds =
      this._params.credits_start_at != null
        ? this._timeToSeconds(this._params.credits_start_at)
        : videoDuration - 10;

    // Update the visibility of the 'IntroEndsAt' tag
    this.tag('IntroEndsAt').visible = introEndsAtInSeconds > currentTime;
    if (introEndsAtInSeconds < currentTime) {
      this._setState('ProgressBar');
    }
    // Calculate and update the progress bar width, ensure it doesn't exceed its max width
    const targetProgressBarWidth = Math.min(Math.round((currentTime / videoDuration) * 1600), 1600);
    this.tag('ProgressBar').setSmooth('w', targetProgressBarWidth);

    // Update the current time and duration labels

    this.patch({
      CurrentTimeLabel: undefined,
    });
    // this.tag('CurrentTimeLabel').text.text = this._formatTime(currentTime);
    this.patch({
      CurrentTimeLabel: {
        w: 100,
        visible: this.tag('ProgressContainer').visible,
        text: {
          text: this._formatTime(currentTime),
          fontFace: 'OpenSans-Regular',
          textAlign: 'center',
          fontSize: 25,
          textColor: Colors('#ffffff').get(),
          shadow: true,
          shadowColor: Colors('#000000').get(),
          shadowOffsetX: 1,
          shadowOffsetY: 1,
          shadowBlur: 1,
        },
        x: 45,
        y: 947,
      },
    });
    // Check if the credits should be watched and update modal visibility
    if (!watchCredits) {
      this._checkModalVisibility(currentTime, creditsStartAtInSeconds);
    }
  }

  _checkModalVisibility(currentTime, creditsStartAtInSeconds) {
    let profileInfo = JSON.parse(localStorage.getItem('profileInfo'));
    let VODList = JSON.parse(localStorage.getItem('VODList'));
    if (profileInfo.autoplay && VODList && VODList.length > 0) {
      if (currentTime >= creditsStartAtInSeconds) {
        this.tag('PopupModal').patch({
          visible: true,
        });
        this.tag('Overlay').visible = true;
        this._setState('PopupModal');
      } else {
        this.tag('PopupModal').patch({
          visible: false,
        });
        this.tag('Overlay').visible = false;
      }
    }
  }

  _resetUI() {
    this.tag('ProgressBar').setSmooth('w', 0);
    this.tag('CurrentTimeLabel').text.text = '00:00:00';
    this.tag('SubtitleText').text.text = '';
  }

  _adjustSubtitleTextPosition(normalPosition) {
    const newY = normalPosition ? 930 : 830; // Adjust the y position as needed
    this.tag('SubtitleText').setSmooth('y', newY);
  }

  _subtitlePosition() {
    if (this.tag('ProgressContainer').visible) {
      return 830;
    } else {
      return 930;
    }
  }
  _skipVideo(offset) {
    offsetTime += offset;
    this._adjustSubtitleTextPosition(false);
    VideoPlayer.pause();

    clearTimeout(this._seekTimeout);

    // Set a new timeout to delay the seek operation by 500ms
    this._seekTimeout = setTimeout(() => {
      VideoPlayer.seek(VideoPlayer.currentTime + offsetTime);
      offsetTime = 0;
      VideoPlayer.play();
    }, 500); // 500ms delay

    this._updateProgressBarAndTime();

    if (VideoPlayer.playing === false) {
    }
  }

  _formatTime(time) {
    // Convert seconds to HH:MM:SS format
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = Math.floor(time % 60);
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds
      .toString()
      .padStart(2, '0')}`;
  }

  _timeToSeconds(timeString) {
    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  }

  _hideUIElements() {
    this.tag('ProgressContainer').visible = false;
    this.tag('CurrentTimeLabel').visible = false;
    this.tag('DurationLabel').visible = false;
    this.tag('FocusCtn').visible = false;
  }

  _showUIElements() {
    this.tag('ProgressContainer').visible = true;
    this.tag('CurrentTimeLabel').visible = true;
    this.tag('DurationLabel').visible = true;
    this.tag('FocusCtn').visible = true;
  }

  _restartHideUITimer(delay) {
    if (this._hideUITimer) {
      clearTimeout(this._hideUITimer);
    }

    this._hideUITimer = setTimeout(() => {
      this._hideUIElements();
      this._adjustSubtitleTextPosition(true);
    }, delay);
  }
}
